import React, { useEffect, useRef } from 'react'
import 'aframe'
import 'mind-ar/dist/mindar-image-aframe.prod.js'

const MindARViewer = ({
  mute,
  videos,
  mind,
  toggleVolumeControl,
  loadingBackground,
  loadingDotsColor
}) => {
  const sceneRef = useRef(null)
  const targetRef = useRef([])
  const videoRef = useRef([])

  useEffect(() => {
    const sceneEl = sceneRef.current
    const arSystem = sceneEl.systems['mindar-image-system']
    sceneEl.addEventListener('renderstart', () => {
      arSystem.start()
    })
    return () => {
      arSystem.stop()
    }
  }, [])

  useEffect(() => {
    targetRef.current.forEach((target, index) => {
      target.addEventListener('targetFound', () => {
        toggleVolumeControl(true)
        videoRef.current[index].play()
      })
      target.addEventListener('targetLost', () => {
        toggleVolumeControl(false)
        videoRef.current[index].currentTime = 0
        videoRef.current[index].pause()
      })
    })
  }, [toggleVolumeControl, videos])

  return (
    <a-scene
      ref={sceneRef}
      mindar-image={`imageTargetSrc: ${mind}; autoStart: false; uiLoading: no; uiError: no; uiScanning: no;`}
      color-space='sRGB'
      embedded
      renderer='colorManagement: true, physicallyCorrectLights'
      vr-mode-ui='enabled: false'
      device-orientation-permission-ui='enabled: false'
      loading-screen={`dotsColor: ${loadingDotsColor}; backgroundColor: ${loadingBackground}`}
    >
      <a-assets>
        {videos.map((v, index) => {
          return (
            <video
              id={`video${index}`}
              key={`video${index}`}
              loop
              crossOrigin='anonymous'
              preload='auto'
              muted={mute}
              ref={(el) => {
                videoRef.current[index] = el
                return el
              }}
              playsInline
              webkit-playsinline='true'
              src={v.src}
            >
              <source type={v.type} src={v.src} />
            </video>
          )
        })}
      </a-assets>
      <a-camera position='0 0 0' look-controls='enabled: false;'></a-camera>
      {videos.map((v, index) => (
        <a-entity
          key={index}
          mindar-image-target={`targetIndex: ${index}`}
          ref={(el) => {
            targetRef.current[index] = el
            return el
          }}
        >
          <a-plane
            src={`#video${index}`}
            position='0 0 0'
            height={v.height}
            width={v.width}
            rotation='0 0 0'
          ></a-plane>
        </a-entity>
      ))}
    </a-scene>
  )
}

export default MindARViewer
